<template>
    <span hidden></span>
</template>

<script setup>
import { onBeforeUnmount, onMounted } from "vue";

// Blade renders the splash outside #app so it covers the page before Vue starts.
let splashTimer;
onMounted(() => {
    splashTimer = setTimeout(() => {
        const loadingScreen = document.getElementById("loadingscreen");
        if (loadingScreen) {
            loadingScreen.style.display = "none";
        }
    }, 5000);
});
onBeforeUnmount(() => clearTimeout(splashTimer));
</script>
